import { render, staticRenderFns } from "./ShowBasicPoll.vue?vue&type=template&id=6321225e&scoped=true&"
import script from "./ShowBasicPoll.vue?vue&type=script&lang=ts&"
export * from "./ShowBasicPoll.vue?vue&type=script&lang=ts&"
import style0 from "./ShowBasicPoll.vue?vue&type=style&index=0&id=6321225e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6321225e",
  null
  
)

export default component.exports